module.exports = __webpack_public_path__ + "img/panicbutton.5afb0a54.svg";